var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Kursmanager - Leistungen'),"lastPath":-1,"showDrawer":false}}),_c('Evaluation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }